// extracted by mini-css-extract-plugin
export default {"selectorButton":"_pqx2ty","btnLink":"_3d92ep"};